var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("p", { staticClass: "text-h5" }, [_vm._v("近期交易")]),
      _vm.sales
        ? _c(
            "el-table",
            {
              staticStyle: { width: "100%", "padding-top": "15px" },
              attrs: { data: _vm.sales.rows },
            },
            [
              _c("el-table-column", {
                attrs: { label: "機台編號" },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function (scope) {
                        return [_vm._v(" " + _vm._s(scope.row.AssetNo) + " ")]
                      },
                    },
                  ],
                  null,
                  false,
                  992003980
                ),
              }),
              _c("el-table-column", {
                attrs: { label: "客戶" },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _vm._v(" " + _vm._s(scope.row.mvm.client.name) + " "),
                        ]
                      },
                    },
                  ],
                  null,
                  false,
                  3486225301
                ),
              }),
              _c("el-table-column", {
                attrs: { label: "品名" },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _vm._v(" " + _vm._s(scope.row.ProductName) + " "),
                        ]
                      },
                    },
                  ],
                  null,
                  false,
                  1446351953
                ),
              }),
              _c("el-table-column", {
                attrs: { label: "價格" },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function (scope) {
                        return [_vm._v(" " + _vm._s(scope.row.PayAmt) + " ")]
                      },
                    },
                  ],
                  null,
                  false,
                  3793273165
                ),
              }),
              _c("el-table-column", {
                attrs: { label: "結果" },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _vm._v(
                            " " +
                              _vm._s(_vm._f("resultFilter")(scope.row.Result)) +
                              " "
                          ),
                        ]
                      },
                    },
                  ],
                  null,
                  false,
                  4233660772
                ),
              }),
              _c("el-table-column", {
                attrs: { label: "交易時間" },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm._f("dateTimeFilter")(scope.row.created_at)
                              ) +
                              " "
                          ),
                        ]
                      },
                    },
                  ],
                  null,
                  false,
                  1390769423
                ),
              }),
            ],
            1
          )
        : _vm._e(),
      _c("div", { staticClass: "text-center bg-white py-2" }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }